import { motion } from "framer-motion";
import { PHILOSOPHIES, PUBLICATIONS } from "../data/content";
import { usePortfolio } from "../lib/usePortfolio";

const EASE = [0.22, 1, 0.36, 1];

export default function About() {
  const { portrait: PORTRAIT } = usePortfolio();
  return (
    <section id="about" data-testid="about-section" className="relative py-28 md:py-40">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid md:grid-cols-12 gap-12 md:gap-16 items-start">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 1, ease: EASE }}
          className="md:col-span-5"
        >
          <div className="relative border border-gold/25 p-3">
            <div className="absolute -top-2 -left-2 h-6 w-6 border-t border-l border-gold/60" />
            <div className="absolute -bottom-2 -right-2 h-6 w-6 border-b border-r border-gold/60" />
            <img
              src={PORTRAIT.url}
              alt={PORTRAIT.alt}
              loading="lazy"
              className="w-full aspect-[4/5] object-cover"
            />
          </div>
          <p className="mt-4 text-[10px] font-mono tracking-[0.25em] uppercase text-stone-500">
            {PORTRAIT.caption}
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 1, delay: 0.12, ease: EASE }}
          className="md:col-span-7"
        >
          <p className="text-[11px] font-mono tracking-[0.25em] uppercase text-stone-500">
            03 // The Artists
          </p>
          <h2 className="mt-4 font-serif text-2xl sm:text-3xl lg:text-4xl font-normal tracking-tight text-ivory">
            Julian Vance <span className="italic text-champagne">&</span> Clara Moreau
          </h2>
          <p className="mt-6 max-w-xl text-sm sm:text-base font-light leading-relaxed text-stone-300">
            A husband-and-wife atelier devoted to the belief that a wedding is not an event to be
            staged, but a poem to be witnessed. From the misted terraces of Lake Como to the temple
            gardens of Kyoto, we follow quiet light and louder hearts.
          </p>
          <p className="mt-4 max-w-xl text-sm sm:text-base font-light leading-relaxed text-stone-400">
            Trained in editorial fashion and documentary cinema respectively, our dual perspective
            marries couture composition with unguarded truth.
          </p>

          <ul className="mt-8 space-y-3">
            {PHILOSOPHIES.map((item) => (
              <li key={item} className="flex items-center gap-4 text-sm font-light text-stone-300">
                <span className="h-px w-8 bg-gold/60 shrink-0" />
                {item}
              </li>
            ))}
          </ul>

          <div className="mt-10 border-t border-white/10 pt-6">
            <p className="text-[10px] font-mono tracking-[0.25em] uppercase text-stone-500">
              As Featured In
            </p>
            <div className="mt-3 flex flex-wrap gap-x-6 gap-y-2">
              {PUBLICATIONS.map((pub) => (
                <span key={pub} className="font-serif italic text-base text-stone-400">
                  {pub}
                </span>
              ))}
            </div>
          </div>

          <p className="mt-10 font-serif italic text-3xl text-champagne/80">Julian & Clara</p>
        </motion.div>
      </div>
    </section>
  );
}
